var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6401 12.99C25.2901 12.99 24.9601 13.05 24.6501 13.14C24.6501 13.09 24.6601 13.04 24.6601 12.99C24.6601 8.95 21.3801 5.67 17.3401 5.67C13.9301 5.67 11.0701 8.01 10.2601 11.17C9.99007 11.12 9.71007 11.09 9.43007 11.09C6.88007 11.09 4.82007 13.15 4.82007 15.7C4.82007 17.99 6.49007 19.87 8.68007 20.24V20.32H17.3401H17.3501H17.3601H25.3601C25.4601 20.33 25.5601 20.35 25.6601 20.35C27.6901 20.35 29.3401 18.7 29.3401 16.67C29.3401 14.64 27.6701 12.99 25.6401 12.99Z",
    fill: "#D2E2F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.12 18.71C23.76 18.71 23.42 18.78 23.1 18.87C23.1 18.82 23.11 18.77 23.11 18.71C23.11 14.55 19.73 11.17 15.57 11.17C12.05 11.17 9.11003 13.58 8.27003 16.84C7.99003 16.79 7.71003 16.75 7.41003 16.75C4.79003 16.75 2.66003 18.88 2.66003 21.5C2.66003 23.86 4.40003 25.95 6.65003 26.32L6.69003 26.33H15.6H15.61H15.62H23.72C23.91 26.32 24.05 26.32 24.15 26.32C26.24 26.32 27.91 24.58 27.91 22.49C27.91 20.4 26.21 18.71 24.12 18.71Z",
    fill: "#9EC5FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.a140654b1065a9ec5f10720095c9ff67.svg";
export { ForwardRef as ReactComponent };